module.exports = __webpack_public_path__ + "ggmpa/img/weixin.4b01a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin.png
// module id = AVav
// module chunks = 1 2 3 4 5